import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const BLOCK_SELECTOR = '[data-drawer-menu-content]'

export class DrawerMenuPage extends BaseComponent {
  mountComponent(): void {
    const block = $el(BLOCK_SELECTOR, this)
    this.addListener(block, 'scroll', this.handleBlockScroll)
  }

  handleBlockScroll = (): void => {
    const block = $el(BLOCK_SELECTOR, this)

    if (block) {
      this.toggleAttribute('header-shadow-visible', block.scrollTop > 0)
    }
  }
}
